/**
 * URL クエリパラメータから数値 ID を解決する。
 *
 * `id` パラメータを優先し、存在しなければ `query` パラメータ（v1互換）を使用する。
 * 有効な正整数でない場合は null を返す。
 *
 * @example
 * // ?id=123 → 123
 * // ?query=123 → 123
 * // ?id=123&query=456 → 123 (id が優先)
 * // ?query=abc → null
 */
export function resolveIdParam(
  idParam: string | string[] | undefined,
  rawQueryParam: string | string[] | undefined,
): number | null {
  const raw = typeof idParam === 'string' ? idParam : typeof rawQueryParam === 'string' ? rawQueryParam : null
  if (raw === null) return null
  const n = Number(raw)
  return Number.isInteger(n) && n > 0 ? n : null
}
